<template>
 <Drawer
      v-model="openForm"
      title="当前节点"
      footer-hide
      width="300"
      height="400"
      :transfer="true"
    >
    <Steps :current="current" direction="vertical">
      <Step
        v-for="(x, index) in steps"
        :key="index"
        :title="x.name"
        >
        <template slot="content">
        <ly-form-item label="处理内容">
          {{ x.content}}
        </ly-form-item>
        <ly-form-item label="负责人员">
          {{ x.user1}}
        </ly-form-item></template>
      </Step>
    </Steps>
      </Drawer>
</template>
<script>
export default {
  data() {
    return {
      openForm:false,
      item:{
        id:''
      },
      steps:[],
      nodeId:'',
      current:0
    }
  },
  methods: {
    reach(v){
      this.openForm=true;
      this.item.id=v.flowId;
      this.nodeId=v.nodeId;
      this.getDetail();
    },
    getDetail(){
      //https://cloud.ly-gps.com/cloud-rmm-server-dpm/apply
      //https://cloud.ly-gps.com/cloud-rmm-server-dpm/repair
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: this.axios.flow + "/flowConfig/info",
        data: this.item,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
       var data=res.data.data;
       var n=data.nodeList.filter(function(item){
        return item.type==1;
       })

      for (var i=0;i<n.length; i++) {
          var arr=[];
          for (const j in n[i].user) {
             arr.push(n[i].user[j].name)
          }
          n[i].user1=arr.join(' , ');
          if(n[i].id==this.nodeId){
            this.current=i;
          }
      }
       this.steps=n;
      });
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/components/yhgl/nowNoName.vue